import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_btn = _resolveComponent("q-btn")!

  return (_ctx.isGranted('RESOLVE_POST'))
    ? (_openBlock(), _createBlock(_component_q_btn, {
        key: 0,
        color: _ctx.color,
        label: _ctx.label,
        loading: _ctx.isLoading,
        title: _ctx.title,
        onClick: _ctx.resolve
      }, null, 8, ["color", "label", "loading", "title", "onClick"]))
    : _createCommentVNode("", true)
}